module.exports = __webpack_public_path__ + "img/bg4.17d018b8.png";